import { SiteSlug, ThemeNames } from '../types.js';
import GoodLifePlus from './good-life-plus.js';
import Lions from './lions.js';
import Rangers from './rangers.js';
import Saints from './saints.js';
import TrueNorth from './true-north.js';
const defaultSite = SiteSlug.GoodLifePlus;
export const themes = {
    [SiteSlug.GoodLifePlus]: GoodLifePlus,
    [SiteSlug.Rangers]: Rangers,
    [SiteSlug.Saints]: Saints,
    [SiteSlug.Lions]: Lions,
    [SiteSlug.TrueNorth]: TrueNorth,
};
export const getTheme = (siteSlug = defaultSite) => ({
    ...(themes[siteSlug] ?? themes[defaultSite]),
    themeNames: ThemeNames,
});
